// extracted by mini-css-extract-plugin
export var choice = "styles-module--choice--OCXRB";
export var skip = "styles-module--skip--2g-Dj";